import { useState, useEffect } from 'react';

/**
 * A custom hook that tracks whether the page has been scrolled past a certain threshold.
 * @param {number} scrollThreshold The scroll distance from the top in pixels to trigger the state change. Defaults to 10.
 * @returns {boolean} A boolean value indicating if the page is scrolled.
 */
export const useScroll = (scrollThreshold = 10) => {
    // State to store the scrolled status
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        // Function to handle the scroll event
        const handleScroll = () => {
            // Check if the window's scroll position is past the threshold
            if (window.scrollY > scrollThreshold) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        // Add the scroll event listener when the component mounts
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        // This is crucial to prevent memory leaks
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollThreshold]); // The empty dependency array ensures this effect runs only once

    // Return the boolean value
    return isScrolled;
};